<div *ngIf="displayError" class="field-error-container">
    <span class="glyphicon glyphicon-remove form-control-feedback fix-error-icon"></span>
    <div class="error-msg" [innerHtml]="errorMsg | safeHtml"></div>
</div>
